import Cookies from 'js-cookie'
import { Popover } from './popover'

const FakeBeacon = {
  init: function () {
    const contactButtons = document.querySelectorAll('.js-beacon')
    const beacon = document.querySelector('.js-load-beacon')

    if (Cookies.get('hs-beacon') === 'open') {
      // 1. Beacon was already opened on another page
      FakeBeacon.continue(beacon)
    } else if (beacon !== undefined) {
      // 2. If not, delay loading and show a fake beacon
      beacon.classList.remove('hidden')
      beacon.addEventListener('click', function () {
        FakeBeacon.load(beacon)
      })
    }

    // Show beacon on contact buttons
    contactButtons.forEach(function (el) {
      el.addEventListener('click', FakeBeacon.contactButtonHandler)
    })
  },

  contactButtonHandler: function (event) {
    event.preventDefault()
    const beacon = document.querySelector('.js-load-beacon')

    Popover.close()

    if (typeof Beacon !== 'undefined') {
      // Show existing Beacon if it's already loaded
      window.Beacon('open')
    } else {
      // Load Beacon if it isn't loaded
      FakeBeacon.load(beacon)
    }
  },

  loadScript: function (el) {
    !(function (e, t, n) {
      function a() {
        const n = t.createElement('script')

        n.type = 'text/javascript'
        n.async = true
        n.src = 'https://beacon-v2.helpscout.net'
        el.parentNode.insertBefore(n, el)
      }

      if (
        ((e.Beacon = n =
          function (t, n, a) {
            e.Beacon.readyQueue.push({ method: t, options: n, data: a })
          }),
        (n.readyQueue = []),
        'complete' === t.readyState)
      )
        return a()

      e.addEventListener('load', a, !1)
    })(window, document, window.Beacon || function () {}) // eslint-disable-line @typescript-eslint/no-empty-function
    window.Beacon('init', '37be4d1b-372d-4387-9669-d385ada6795b')
  },

  continue: function (el) {
    // Trigger beacon loading
    FakeBeacon.loadScript(el)

    // Once loaded, open it to continue the conversation
    window.Beacon('once', 'ready', function () {
      FakeBeacon.identify()
      window.Beacon('open')
    })

    // Once closed, revert to normal behavior
    FakeBeacon.close()
  },

  load: function (el) {
    // Trigger beacon loading
    FakeBeacon.loadScript(el)

    // Indicate that it's loading
    FakeBeacon.loading(el)

    // Once loaded, hide the fake beacon and open the real one
    window.Beacon('once', 'ready', function () {
      FakeBeacon.identify()
      FakeBeacon.hide(el)
      window.Beacon('open')
      Cookies.set('hs-beacon', 'open', { expires: 1 })
    })

    // Once closed, revert to normal behavior
    FakeBeacon.close()
  },

  close: function () {
    window.Beacon('on', 'close', function () {
      Cookies.remove('hs-beacon')
    })
  },

  loading: function (el) {
    el.classList.add('is-loading')
  },

  hide: function (el) {
    el.remove()
  },

  identify: function () {
    /* eslint-disable no-undef */

    // Check if we have identity info.
    // Identity data not present if the user is logged out or has DNT enabled
    // Populated from app/views/shared/_beacon.html.erb
    if (typeof beaconIdentity !== 'undefined') {
      window.Beacon('identify', beaconIdentity)
    }
  },
}

window.addEventListener('DOMContentLoaded', FakeBeacon.init)
